import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=223eea3b&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=223eea3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223eea3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('223eea3b')) {
      api.createRecord('223eea3b', component.options)
    } else {
      api.reload('223eea3b', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=223eea3b&scoped=true&", function () {
      api.rerender('223eea3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vfxGzR4HdcIJ/JS/comp/GuestBox.vue"
export default component.exports